import React from 'react';
import OptionsCommon from 'components/quote_builder_widget/form/options/OptionsCommon.jsx';

const OptionBoolean = ({ id, drawing, option, unit }) => {
  const formattedValue = (value) => value;

  const [isVisible, value, onChange, highlighted] = OptionsCommon({
    formattedValue,
    id,
    drawing,
    option,
    unit,
  });

  if (!isVisible) {
    return <input type="hidden" name={option.name} value={value} />;
  }

  return (
    <div className="row mb-6" data-widget-element="form-group">
      <div className="input-group mb-3">
        <span className="input-group-text font13" data-widget-element="label">{option.presented_name}</span>
        <div className="form-control d-flex align-items-center" data-widget-element="input-wrapper">
          <input
            name={"__" + option.name}
            type="checkbox"
            value="1"
            onChange={onChange}
            checked={value == 1}
            autoComplete="off"
            readOnly={option.readonly_option}
            data-widget-element="checkbox"
          />
          <input type="hidden" name={option.name} value={value} />
        </div>
      </div>
    </div>
  );
};

export default OptionBoolean;
